import styled from 'styled-components';
import RouteContainer from "../../../common/styles/RouteContainer"
import RouteTitle from "../../../common/RouteTitle/RouteTitle"
import booksitoutIcon from "../../../config/BooksitoutIcon"
import RouteTitleConfig from "../../../config/RouteTitleConfig"
import RowSpacer from '../../../common/styles/RowSpacer';
import useHtmlTitle from "../../../common/useHtmlTitle";
import {usePopularBooks} from "./usePopularBooks";
import PopularBookListRowLoading from "./PopularBookListRowLoading";
import PopularBookListRow from "./PopularBookListRow";
import NoContent from '../../../common/NoContent';


const PopularBookRoute = () => {
    useHtmlTitle('인기책')

    const [isLoading, popularBooks] = usePopularBooks(100)

    return (
        <RouteContainer>
            <RouteTitle
                icon={<booksitoutIcon.community/>}
                title={'베스트셀러'}
                subTitle={'국내 주요 서점의 순위를 종합한 베스트셀러를 만나 보세요'}
                currentKey={'popular'}
                buttons={RouteTitleConfig.Community}
                rightUi={undefined}
            />
            <RowSpacer/>

            {isLoading ? (
                <Row>
                    {Array(100).fill(0).map((_, index) => index + 1).map(index =>
                        <Col key={index}>
                            <PopularBookListRowLoading index={index}/>
                        </Col>
                    )}
                </Row>
            ) : popularBooks.length === 0 ? (
                <>
                    <RowSpacer size={40}/>
                    <NoContent message={'베스트셀러 정보를 불러올 수 없어요'} />
                    <RowSpacer size={40}/>
                </>
            ) : (
                <Row>
                    {popularBooks.slice(0, 100).map(book =>
                        <Col key={book.isbn}>
                            <PopularBookListRow popularBook={book} colorType={'card'}/>
                        </Col>
                    )}
                </Row>
            )}
            <RowSpacer size={40}/>
        </RouteContainer>
    )
}

const Row = styled.div.attrs({
    className: 'row'
})`
`;

const Col = styled.div.attrs({
    className: 'col-12'
})`
`;


export default PopularBookRoute